const headless = {
  url: "https://shasa-mx-sandbox.myshopify.com/api/2025-07/graphql.json",
  hash: "b078dc131d620cb12f860a300ed09ff0",
  fetch: async (query) => {
    const request = {
      async: true,
      crossDomain: true,
      method: "POST",
      headers: {
        "X-Shopify-Storefront-Access-Token": headless.hash,
        "Content-Type": "application/graphql",
      },
      body: query,
    };
    const response = await fetch(headless.url, request);
    const res = await response.json();
    if (res.data?.nodes) return res.data.nodes;
    else if (res.data) return res.data;
    else return res;
  },
};
class Card {
  constructor(id, container, source, attributionKey) {
    this.id = id;
    this.container = document.getElementById(container);
    this.source = source;
    this.attributionKey = attributionKey ? `?nosto=${attributionKey}` : "";
    this.carousel = attributionKey || "";
    this.create();
  }
  async create() {
    const query = `
      query {
        product(id: "gid://shopify/Product/${this.id}") {
          gid: id
          title
          list: metafield(namespace: "custom", key: "product_list") {
            value
          }
          color: metafield(namespace: "custom", key: "color") {
            value
          }
        }
      }
    `;
    const { product } = await headless.fetch(query);
    if (product && product.gid) {
      product.id = product.gid.split("/").at(-1);
      const query = `
        query {
          nodes(ids: ${product.list.value}) {
            ... on Product {
              id
              onlineStoreUrl
              color: metafield(namespace: "custom", key: "color") {
                value
              }
              images(first: 1) {
                edges {
                  node {
                    url
                    altText
                  }
                }
              }
              variants(first: 20) {
                edges {
                  node {
                    id
                    title
                    availableForSale
                    price{
                      amount
                    }
                    compareAtPrice{
                      amount
                    }
                  }
                }
              }
            }
          }
        }
      `;
      const productList = await headless.fetch(query);
      const productColors = [];
      for (const product of productList) {
        if (product && product.images.edges.length > 0) {
          const compareAtPrice = product.variants.edges[0].node.compareAtPrice?.amount;
          const productDetails = {
            id: product.id.split("/").at(-1),
            color: product.color.value,
            class: product.color.value
              .trim()
              .replace(/[^a-zA-Z]/g, "")
              .toLowerCase(),
            image: product.images.edges[0].node.url,
            url: product.onlineStoreUrl,
            price: product.variants.edges[0].node.price.amount,
            compareAtPrice: compareAtPrice ? `$${compareAtPrice}0` : "",
            variants: product.variants.edges
              .map((variant) => {
                return {
                  title: variant.node.title,
                  id: variant.node.id.split("/").at(-1),
                  availableForSale: variant.node.availableForSale,
                };
              })
              .filter((variant) => variant.availableForSale),
          };
          if (compareAtPrice) {
            productDetails.discount = Math.ceil(100-((productDetails.price / compareAtPrice) * 100))
          }
          productColors.push(productDetails);
        }
      }
      // //Put the current color first
      if (productColors.length > 1) {
        const index = productColors.findIndex(
          (p) => p.color == product.color.value
        );
        productColors.unshift(productColors.splice(index, 1)[0]);
      }
      const card = document.createElement("div");
      card.className = "card";
      card.innerHTML = `
        <div>
          ${productColors.map((productColor) => `
            <label class="card-product ${productColor.variants.length === 0 ? "unavailable" : ""}">
              <input type="radio" class="hidden" id="${this.carousel}-${productColor.class}-${product.id}" name="${this.carousel}-${product.id}" value="${productColor.color}" ${productColor.color == product.color.value ? "checked" : ""}>
              <a
              ${this.source === "nostosearch"
              ? `href="${productColor.url}?&fromnostosearch=true" onclick="window.recordClick('${productColor.id}', '${productColor.url}')"`
              : `href="${productColor.url}${this.attributionKey}"`
              }>
                <img loading="lazy" src="${productColor.image}&width=600" alt="${product.title}" />
                <div class="card-title">${product.title}</div>
                <div class="flex price-container">
                  <p>$${productColor.price}0</p>
                  <p><del>${productColor.compareAtPrice}</del></p>
                </div>
              </a>
              <div class="size-container flex justify-center">
                ${productColor.variants.length === 0 ? "<div class='size'><b>AGOTADO</b></div>" :
                productColor.variants.map((variant) =>
                  `<div class="size" onclick="cart.add(${variant.id})">${variant.title}</div>`
                ).join("")}
              </div>
              ${productColor.discount ? `
                <div class="discount-label sale">-${productColor.discount}%</div>
              ` : ""}
            </label>
          `).join("")}
        </div>
        <div class="swatch-container flex">
          ${productColors.map((productColor) =>
            `<label class="swatch swatch-${productColor.class}" for="${this.carousel}-${productColor.class}-${product.id}"></label>`
          ).join("")}
        </div>
      `;
      // console.log('CONTAINER')
      // console.log(this.container)
      this.container.appendChild(card);
    }
  }
}
window.addEventListener("load", () => {
  cart.drawer = document.querySelector("cart-drawer");
});